import { getData } from '~/utils/service';
import { CalendarEvent } from './types';

export const fetchCalendarEvents = (
  start: string,
  end: string,
  includeDrafts = false
): Promise<CalendarEvent[]> =>
  getData('hlxCalendarEvents', {
    params: { start, end, include_drafts: String(includeDrafts) },
  });
